import React, { Suspense } from 'react';

// The viewer bundles pdf.js and SheetJS (~1MB together); load it the first
// time a file is actually opened instead of with every page that can open one.
const FileViewerModal = React.lazy(() => import('./FileViewerModal'));

/** Drop-in for FileViewerModal (same props). Renders nothing until loaded. */
export default function LazyFileViewerModal(props) {
  return (
    <Suspense fallback={null}>
      <FileViewerModal {...props} />
    </Suspense>
  );
}
